export default __webpack_public_path__ + "static/media/home.37022ab2.svg";